module.exports = __webpack_public_path__ + "img/empty_photo.ae745d70.png";